module.exports = __webpack_public_path__ + "media/images/flags/ag-9d1a151c1f01b33e68c5d8274f049c59.svg";